





























































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';
import IAuthentication from '@/store/models/IAuthentication';
import IOutboundDeliveryNotes from '@/store/models/IOutboundDeliveryNotes';
import IOutboundDeliveryNotesDetail from '@/store/models/IOutboundDeliveryNotesDetail';
import OutboundDeliveryNotesApi from '../store/api/OutboundDeliveryNotesApi';
import moment from 'moment';
import OutbounDeliveryNotesDetailApi from '../store/api/OutboundDeliveryNotesDetailApi';
import INotification from '@/store/models/INotification';
import NotificationApi from '@/store/api/NotificationApi';
import IListStatusOutboundDeliveryNotes from '@/store/models/IListStatusOutboundDeliveryNotes';
import IOutboundDetail from '@/store/models/IOutboundDetail';
import OutboundDetailApi from '../store/api/OutboundDetailApi';
import IOutbound from '@/store/models/IOutbound';
import OutboundApi from '../store/api/OutboundApi';
import IStock from '@/store/models/IStock';
import StockApi from '../store/api/StockApi';
import SettingsCompanyApi from '@/store/api/SettingsCompanyApi';
import OutboundDeliveryNotesDetailSelector from '@/components/selectors/Outbounds/OutboundDeliveryNoteDetailSelector.vue';
import ListStatusOutboundsDeliveryNotesApi from '@/store/api/ListStatusOutboundsDeliveryNotesApi';
import { SettingsCompany } from '@/components/shared/SettingsCompany';
import CustomerApi from '@/store/api/CustomerApi';
import ICustomer from '@/store/models/ICustomer';
import IWarehouse from '@/store/models/IWarehouse';
import WarehouseApi from '../store/api/WarehouseApi';
@Component({
    components: {
        Snackbar,
        OutboundDeliveryNotesDetailSelector
    }
})
export default class InboundsShared extends Vue {
    searchOutboundDeliveryNotes: string = "";
    permissions: IRolePermission[] = [];
    outboundDeliveryNotesApi : OutboundDeliveryNotesApi;
    outboundDeliveryNotesList : IOutboundDeliveryNotes[] = [];
    selectedOutboundDeliveryNotes : IOutboundDeliveryNotes [] = [];
    companyId : string = "";
    userName: string = "";
    isValid: boolean = true;
    dateOut: string = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
    dialog: boolean = false;
    outboundDeliveryNotesDetailList : IOutboundDeliveryNotesDetail[] = [];
    outboundDeliveryNotesDetailApi: OutbounDeliveryNotesDetailApi;
    menu2: boolean = false;
    statusOutboundsList : IListStatusOutboundDeliveryNotes[] = [];
    notificationApi : NotificationApi;
    selectedStatusOutbound: IListStatusOutboundDeliveryNotes = {} as IListStatusOutboundDeliveryNotes;
    overlay: boolean = false;
    outboundDetailApi : OutboundDetailApi;
    selectedOutbound: IOutbound | null = null;
    outboundApi : OutboundApi;
    outboundList : IOutbound[] = [];
    customerStockDeliveryNoteDetail : IStock[] = [];
    outboundDetailList : IOutboundDetail[] = [];
    stockApi: StockApi;
    canModifyCompletedOutbounds : boolean = false;
    settingsCompanyApi: SettingsCompanyApi;
    listStatusOutboundsDeliveryNotesApi: ListStatusOutboundsDeliveryNotesApi;
    showCustomer: boolean = false;
    customerApi : CustomerApi;
    CustomerList : ICustomer[] = [];
    selectedWarehouse: IWarehouse = {} as IWarehouse;
    WarehouseList : IWarehouse[] = [];
    warehouseApi: WarehouseApi;
    headers: any = [
        { text: 'Company source',
            align: 'start',
            value: 'companySourceName'
        },
        { text: 'Company destination', value: 'companyDestinationName' },
        { text: 'Warehouse', value: 'warehouseName' },
        { text: 'Customer', value: 'customerName' },
        { text: 'Code Delivery Note', value: 'code' },
        { text: 'Dossier Number Source', value: 'codeSource' },
        { text: 'Dossier Number Destination', value: 'codeDestingation' },
        { text: 'Date out', value: 'dateOut' },
        { text: 'Description', value: 'description' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    
    sortBy: string = 'dateOut';
    sortDesc: boolean = false;
    editedIndex : number = -1;
    editedItem : IOutboundDeliveryNotes = {
        id: "",
        idOutbound: "",
        idCompanySource: "",
        companySourceName: "",
        idCompanyDestination: "",
        companyDestinationName: "",
        idWarehouse: "",
        warehouseName: "",
        idCustomer: "",
        customerName: "",
        code: "",
        dateOut: new Date(),
        description: "",
        statusName: "",
        idStatus: "",
        codeDestination: "",
        codeSource: "",
        idDock: "",
        dockName: "",
        dockPicked: false
    }
    defaultItem : IOutboundDeliveryNotes = {
        id: "",
        idOutbound: "",
        idCompanySource: "",
        companySourceName: "",
        idCompanyDestination: "",
        companyDestinationName: "",
        idWarehouse: "",
        warehouseName: "",
        idCustomer: "",
        customerName: "",
        code: "",
        dateOut: new Date(),
        description: "",
        statusName: "",
        idStatus: "",
        codeDestination: "",
        codeSource: "",
        idDock: "",
        dockName: "",
        dockPicked: false
    }
    constructor() {
        super();
        this.outboundDeliveryNotesApi = new OutboundDeliveryNotesApi();
        this.outboundDeliveryNotesDetailApi = new OutbounDeliveryNotesDetailApi();
        this.notificationApi = new NotificationApi();
        this.outboundDetailApi = new OutboundDetailApi("Outbounds");
        this.outboundApi = new OutboundApi();
        this.stockApi = new StockApi();
        this.settingsCompanyApi = new SettingsCompanyApi("Outbounds");
        this.listStatusOutboundsDeliveryNotesApi = new ListStatusOutboundsDeliveryNotesApi();
        this.settingsCompanyApi = new SettingsCompanyApi("Inbounds");
        this.customerApi = new CustomerApi();
        this.warehouseApi = new WarehouseApi();
    }
    
    async created() {
        await this.getPermissions();
        await this.getStatusOutbounds();
        await this.getOutboundsDeliveryNotes();
        await this.getCustomers();
        await this.getWarehouses();
    }

    async getCustomers() {
        this.CustomerList = await this.customerApi.GetCustomers();
    }

    async getWarehouses() {
        this.WarehouseList = await this.warehouseApi.GetWarehouses();
    }

    get formTitle() { return this.editedIndex === -1 ? 'New Delivery Notes' : 'Edit Delivery Notes'; }
    get DateOutFormatted() {
        return this.formatDate(this.dateOut);
    }

    async getStatusOutbounds() {
        this.statusOutboundsList = await this.listStatusOutboundsDeliveryNotesApi.GetListStatusOutboundDeliveryNotes();
    }

    async getOutboundDetails(outboundId : string) {
        this.overlay = true;
        this.outboundDetailList = await this.outboundDetailApi.GetOutboundDetails(outboundId);
        this.overlay = false;
    }
     
    async getOutbounds(idCompany: string) {
        this.overlay = true;
        this.outboundList = await this.outboundApi.GetOutbounds(idCompany);
        this.overlay = false;
    }

    HasPermissionToSave() : boolean {
        if (Object.keys(this.selectedOutboundDeliveryNotes).length !== 0) {
            if (this.permissions[0].isWritable) {
                return true;
            }
        }
        return false;
    }

    formatDate (date: string) {
        if (!date) return null;

        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
    }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    @Watch('value')
    updateSelection(newValue : IOutboundDeliveryNotes | null) {
        if (!newValue || Object.keys(newValue).length === 0) {
            this.selectedOutboundDeliveryNotes = [];
            this.customerStockDeliveryNoteDetail = [];
            this.outboundDetailList = [];
        } else {
            this.overlay = true;
            this.selectedOutboundDeliveryNotes = [newValue];
            this.getOutboundDeliveryNotesDetail(this.selectedOutboundDeliveryNotes[0].id);
            this.overlay = false;
        }
    }

    @Watch('selectedOutboundDeliveryNotes')
    async onChangeSelectedOutboundDeliveryNotes() {
        this.outboundDeliveryNotesDetailList = await this.outboundDeliveryNotesDetailApi.GetOutboundDeliveryNotesDetail(this.selectedOutboundDeliveryNotes[0].id);
        let index = this.WarehouseList.findIndex(w => w.id === this.selectedOutboundDeliveryNotes[0].idWarehouse);
        if (index !== -1) {
            this.selectedWarehouse = this.WarehouseList[index];
        }
    }

    async saveOutboundDeliveryNotesDetail(selectedStockCustomerToDelivery: IStock[]) {
        this.overlay = true;
        let outboundDeliveryNotesDetailApi: OutbounDeliveryNotesDetailApi = new OutbounDeliveryNotesDetailApi();
        for (let stockCustomerToDelivery of selectedStockCustomerToDelivery) {
            let outboundDeliveryNoteDetail = this.createOutbounDeliveryNoteDetail(stockCustomerToDelivery);
            const id = await outboundDeliveryNotesDetailApi.SaveOutboundDeliveryNotesDetail(outboundDeliveryNoteDetail);
            outboundDeliveryNoteDetail.id = id;
            this.outboundDeliveryNotesDetailList.push(outboundDeliveryNoteDetail);
        }
        this.overlay = false;
        this.showMessageInfo(`The outbound delivery note details has been successfully saved`);
    }

    createOutbounDeliveryNoteDetail(stockCustomerToDelivery: IStock) : IOutboundDeliveryNotesDetail {
        let outboundDeliveryNoteDetail : IOutboundDeliveryNotesDetail = {} as IOutboundDeliveryNotesDetail;
        outboundDeliveryNoteDetail.idGood = stockCustomerToDelivery.idGood;
        outboundDeliveryNoteDetail.goodsPerCase = stockCustomerToDelivery.goodsPerCase;
        outboundDeliveryNoteDetail.totalGoods = stockCustomerToDelivery.totalGoods;
        outboundDeliveryNoteDetail.weight = 0;
        outboundDeliveryNoteDetail.bestBeforeDate = stockCustomerToDelivery.bestBeforeDate;
        outboundDeliveryNoteDetail.idOutboundDetail = stockCustomerToDelivery.idOutboundDetail;
        outboundDeliveryNoteDetail.goodName = stockCustomerToDelivery.goodName;
        outboundDeliveryNoteDetail.idListPallet = stockCustomerToDelivery.idListPallet;
        outboundDeliveryNoteDetail.palletName = stockCustomerToDelivery.listPalletName;
        outboundDeliveryNoteDetail.idPallet = stockCustomerToDelivery.idPallet;
        outboundDeliveryNoteDetail.casesPerPallet = stockCustomerToDelivery.totalCases;
        outboundDeliveryNoteDetail.totalCases = stockCustomerToDelivery.totalCases;
        outboundDeliveryNoteDetail.idOutboundDeliveryNote = this.selectedOutboundDeliveryNotes[0].id;
        
        return outboundDeliveryNoteDetail;
    }

    async getCustomerStockFiltered(outboundDeliveryNote : IOutboundDeliveryNotes) {
        this.overlay = true;
        let idGoods : string[] = this.outboundDetailList.map(g => g.idGood);
        let idInboundsDeliveryNoteDetails = this.outboundDetailList.map(g => g.idInboundDeliveryNoteDetail);
        this.customerStockDeliveryNoteDetail = await this.stockApi.GetStockGroupByGoods(idGoods, idInboundsDeliveryNoteDetails);
        this.customerStockDeliveryNoteDetail = this.customerStockDeliveryNoteDetail.filter(c => c.idWarehouse === this.selectedWarehouse.id);
        this.overlay = false;
    }

    deleteOutboundDeliveryNotesDetail (outboundDeliveryNotesDetail: IOutboundDeliveryNotesDetail) {
        confirm('Are you sure you want to delete this outbound delivery note detail?') && this.deleteOutboundDeliveryNotesDetailItem(outboundDeliveryNotesDetail);
    }

    async deleteOutboundDeliveryNotesDetailItem(outboundDeliveryNotesDetail: IOutboundDeliveryNotesDetail) {
        this.overlay = true;
        let result: boolean = await this.outboundDeliveryNotesDetailApi.DeleteOutboundDeliveryNotesDetail(outboundDeliveryNotesDetail.id);
        if (result) {
            const index = this.outboundDeliveryNotesDetailList.indexOf(outboundDeliveryNotesDetail);
            this.outboundDeliveryNotesDetailList.splice(index, 1);
            this.getOutboundDetails(this.selectedOutbound!.id);
            this.showMessageInfo(`The outbound delivery note detail has been successfully deleted`);
        } else {
            const errors: string = this.outboundDeliveryNotesDetailApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async close() : Promise<void> {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    ValidateOutbound() {
        let isValid : boolean = true;
        this.outboundDetailList.forEach(o => {
            if (o.totalCases !== o.inDeliveryNote) {
                isValid = false;
            }
        });
        return isValid;
    }

    async saveOutboundDeliveryNotesShared() {
        if (this.selectedOutboundDeliveryNotes) {
            this.selectedOutboundDeliveryNotes[0].dateOut = new Date(this.dateOut);
            this.selectedOutboundDeliveryNotes[0].description = this.editedItem.description;
            this.selectedOutboundDeliveryNotes[0].idStatus = this.selectedStatusOutbound.id;
            this.overlay = true;
            if (this.selectedStatusOutbound.name.toLocaleLowerCase() === 'completed') {
                await this.getOutboundDetails(this.selectedOutboundDeliveryNotes[0].idOutbound);
                this.ValidateOutbound();
                let isValidOutbound = this.ValidateOutbound();
                if (!isValidOutbound) {
                    this.showMessageWarning("The outbound delivery note status cannot be changed. Please complete the delivery note details");
                } else {
                    confirm('Are you sure you want to completed this outbound delivery note?') && await this.completeDeliveryNote(this.selectedOutboundDeliveryNotes[0].id);
                    this.dialog = false;
                }
            } else {
                this.showMessageInfo(`The inbound deliveryNotes ${this.selectedOutboundDeliveryNotes[0].code} has been successfully saved`);
            }
            
            this.overlay = false;
        }
    }

    async completeDeliveryNote(idDeliveryNote : string) {
        this.overlay = true;
        let statusCompleted = this.statusOutboundsList.find(s => s.isFinished === true) as IListStatusOutboundDeliveryNotes;
        this.selectedOutboundDeliveryNotes[0].idStatus = statusCompleted.id;
        this.selectedOutboundDeliveryNotes[0].statusName = statusCompleted.name;
        await this.outboundDeliveryNotesApi.UpdateOutboundDeliveryNotes(this.selectedOutboundDeliveryNotes[0]);
        await this.sendNotificationToCompanyDestination();
        await this.getOutboundsDeliveryNotes();
        this.showMessageInfo(`The inbound deliveryNotes ${this.selectedOutboundDeliveryNotes[0].code} has been successfully completed`);
        this.dialog = false;
        this.overlay = false;
    }

    async sendNotificationToCompanyDestination() {
        let notification : INotification = {
            subject: "Status outbound delivery note " + this.selectedOutboundDeliveryNotes[0].code,
            body: "The user " + this.userName + " has changed the outbound delivery note " + this.selectedOutboundDeliveryNotes[0].code,
            type: "OUTBOUND DELIVERY NOTE",
            identifier: this.selectedOutboundDeliveryNotes[0].id,
            destinationCompany: this.selectedOutboundDeliveryNotes[0].idCompanyDestination
        };
        await this.notificationApi.SaveNotification(notification);
    }

    async getOutboundDeliveryNotesDetail(idOutboundDeliveryNote: string) {
        this.overlay = true;
        this.outboundDeliveryNotesDetailList = await this.outboundDeliveryNotesDetailApi.GetOutboundDeliveryNotesDetail(idOutboundDeliveryNote);
        this.overlay = false;
    }

    async getPermissions() {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.companyId = userFromStorage.idCompany;
        this.userName = userFromStorage.username;
        this.permissions.push(userFromStorage.rolePermissions.find(r => r.formName === "OutboundsShared"));
        let settingsCompany = SettingsCompany.Settings.ShowCustomer;
        let setting = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
        if (setting.length > 0) {
            if (setting[0].value === "No") {
                this.showCustomer = false;
            } else {
                this.showCustomer = true;
            }
        }
    }

    async getOutboundsDeliveryNotes() {
        let statusPending: IListStatusOutboundDeliveryNotes = {} as IListStatusOutboundDeliveryNotes;
        if (this.statusOutboundsList.length > 0) {
            statusPending = this.statusOutboundsList.find(s => s.isFinished === false) as IListStatusOutboundDeliveryNotes;
            if (statusPending.id !== '' && statusPending.id !== undefined) {
                this.outboundDeliveryNotesList = await this.outboundDeliveryNotesApi.GetOutboundDeliveryNotesShared(this.companyId, statusPending.id);
                if (this.showCustomer === false) {
                    this.outboundDeliveryNotesList.forEach((i) => {
                        let indexCustomer = this.CustomerList.findIndex(c => c.id === i.idCustomer);
                        if (indexCustomer !== -1) {
                            if (i.idCompanyDestination !== this.CustomerList[indexCustomer].idCompany && this.companyId !== i.idCompanySource) {
                                i.customerName = "";
                            }
                        } else {
                            i.customerName = "";
                        }
                    });
                }
            }
        }
    }

    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }

    async editOutboundDeliveryNotes (item: any, dbox = true) {
        if (this.selectedOutboundDeliveryNotes.length > 0) {
            await this.getOutbounds(this.selectedOutboundDeliveryNotes[0].idCompanyDestination);
            this.editedIndex = this.outboundDeliveryNotesList.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.selectedStatusOutbound = this.statusOutboundsList.find(c => c.name.toLocaleLowerCase() === 'pending') as IListStatusOutboundDeliveryNotes;
            let index = this.outboundList.findIndex(s => s.id === item.idOutbound);
            if (index > -1) {
                this.selectedOutbound = this.outboundList[index];
            }
            this.getOutboundDetails(this.selectedOutboundDeliveryNotes[0].idOutbound);
            this.dateOut = moment(new Date(item.dateOut)).format('YYYY-MM-DD');
            this.dialog = true;
        }
    }

    select(item : IOutboundDeliveryNotes) : void {
        let index : number = this.selectedOutboundDeliveryNotes.findIndex(w => w.id === item.id);
        if (index === -1) {
            this.selectedOutboundDeliveryNotes = [item];
        } else {
            let outboundDeliveryNotes = this.selectedOutboundDeliveryNotes.find(w => w.id === item.id);
            if (!outboundDeliveryNotes) {
                this.selectedOutboundDeliveryNotes = [];
            }
        }
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
